import React from 'react';
import { Award } from 'lucide-react';
export function AuthoritySection() {
  return <section className="w-full bg-gray-900 py-16 px-4 border-y-8 border-yellow-400" data-id="element-15">
      <div className="max-w-3xl mx-auto text-center" data-id="element-16">
        <div className="flex justify-center mb-6" data-id="element-17">
          <div className="bg-yellow-400 p-4 rounded-full" data-id="element-18">
            <Award className="w-12 h-12 text-gray-900" data-id="element-19" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-20">
          AUTORIDAD
        </h2>

        <p className="text-xl text-gray-300 mb-2" data-id="element-21">
          Este material fue creado por
        </p>
        <h3 className="text-4xl md:text-5xl font-black text-white mb-2" data-id="element-22">
          Sabrina Bravo
        </h3>
        <p className="text-2xl text-yellow-400 font-medium mb-10" data-id="element-23">
          Psicopedagoga — Argentina
        </p>

        <div className="bg-gray-800 rounded-2xl p-8 border border-gray-700 text-left space-y-6 shadow-2xl" data-id="element-24">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-25">
            Este kit fue desarrollado para acercar herramientas psicopedagógicas
            a las familias y ayudar a los padres a comprender mejor el proceso
            de aprendizaje de sus hijos.
          </p>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed font-bold border-l-4 border-yellow-400 pl-4" data-id="element-26">
            El objetivo es que puedas acompañarlo con más confianza,
            tranquilidad y herramientas prácticas.
          </p>
        </div>
      </div>
    </section>;
}